import React from "react";

import SVGSprite from "@/components/Atoms/SVGSprite";

import Typography from "@/foundation/Typography/V2";

import { StyledIconButton } from "./style";

const IconButton = ({
  children,
  onClick,
  icon,
  iconHeight,
  iconWidth,
  iconMargin,
  typographyVariant,
  ...rest
}) => {
  return (
    <StyledIconButton
      onClick={onClick}
      iconMargin={children ? iconMargin || "8px" : "0px"}
      {...rest}
    >
      {icon && <SVGSprite icon={icon} height={iconHeight} width={iconWidth} />}
      {children &&
        (typographyVariant ? (
          <Typography variant={typographyVariant}>{children}</Typography>
        ) : (
          children
        ))}
    </StyledIconButton>
  );
};

export default IconButton;
